var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    class: "flex h-full relative",
    id: "test"
};
const _hoisted_2 = {
    key: 0,
    class: "w-3/4 h-full p-2 flex items-center justify-center rounded-lg mr-3 border border-gray-100"
};
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "shine h-72 w-96" }, null, -1);
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = { class: "w-3/4 h-full p-2 flex items-center justify-center rounded-lg mr-3 border border-gray-100" };
const _hoisted_6 = ["id", "src"];
const _hoisted_7 = { key: 1 };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", { class: "shine h-3 mt-1 w-44" }, null, -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("div", { class: "shine h-3 mt-1 w-44" }, null, -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("div", { class: "shine h-3 mt-1 w-44" }, null, -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("div", { class: "shine h-10 w-full mt-3" }, null, -1);
const _hoisted_12 = [
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _hoisted_11
];
const _hoisted_13 = {
    key: 2,
    class: "sticky top-0"
};
const _hoisted_14 = {
    key: 0,
    class: "flex items-center my-1"
};
const _hoisted_15 = {
    key: 1,
    class: "flex items-center my-1"
};
const _hoisted_16 = { class: "flex items-center my-1" };
const _hoisted_17 = { class: "flex mt-3 w-full" };
const _hoisted_18 = {
    key: 2,
    class: "my-4"
};
const _hoisted_19 = {
    key: 0,
    id: "user-details",
    class: "pt-3 border-t border-gray-200 mt-4"
};
const _hoisted_20 = { class: "flex items-center" };
import { useEvent } from '@/composable/useEvent';
import MediaServices from '@/services/MediaService';
import { CalendarIcon, Download01Icon, DownloadCloud02Icon, Expand04Icon, HardDriveIcon, Link02Icon, UserCircleIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIButton, UIModal, UIModalContent, UIModalHeader, UITextSmRegular, } from '@gohighlevel/ghl-ui';
import dayjs from 'dayjs';
import { computed, onBeforeMount, onBeforeUnmount, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import useEmitter from '../composable/useEmitter';
import { useStore } from '../store';
import { copyToClipboard, downloadFile, formatBytes } from '../util/helper';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilePreviewModal',
    setup(__props) {
        const emitter = useEmitter();
        const { $state } = useStore();
        const { t } = useI18n();
        const { sendNotification } = useEvent();
        const showModal = ref(false);
        const loading = ref(true);
        const dimensions = ref();
        const details = computed(() => $state.previewItem);
        const hideModal = () => {
            showModal.value = false;
            loading.value = true;
        };
        const findDimensions = () => {
            const imageElement = document.getElementById(`preview-${details.value._id}`);
            dimensions.value = {
                width: imageElement === null || imageElement === void 0 ? void 0 : imageElement.naturalWidth,
                height: imageElement === null || imageElement === void 0 ? void 0 : imageElement.naturalHeight,
            };
            loading.value = false;
        };
        const timeFromNow = (date) => {
            return dayjs(date).fromNow();
        };
        const importToMediaLibrary = () => __awaiter(this, void 0, void 0, function* () {
            const params = {
                altId: $state.altId,
                altType: $state.altType,
                url: details.value.url,
            };
            if ($state.activeCategory === 'unsplash') {
                params.source = $state.activeCategory;
            }
            if ($state.activeCategory === 'pixabay') {
                params.previewUrl = details.value.previewURL;
                params.source = $state.activeCategory;
            }
            try {
                yield MediaServices.addFile(params);
                sendNotification({
                    title: t('common.successfullyAdded'),
                    type: 'success',
                });
            }
            catch (error) {
                sendNotification({
                    title: t('common.failedToAddMedia'),
                    type: 'error',
                });
            }
        });
        const downloadMediaFile = () => __awaiter(this, void 0, void 0, function* () {
            sendNotification({
                title: t('common.downloading'),
                type: 'success',
            });
            const isDownloaded = yield downloadFile(details.value.url, details.value.name);
            if (!isDownloaded)
                sendNotification({
                    title: t('common.downloadFailed'),
                    type: 'error',
                });
        });
        const copyLink = () => {
            copyToClipboard(details.value.url);
            sendNotification({
                title: t('common.copiedClipboard'),
                type: 'success',
            });
        };
        onBeforeMount(() => {
            emitter.on('showPreview', () => {
                showModal.value = true;
            });
        });
        onBeforeUnmount(() => {
            emitter.off('showPreview');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                show: showModal.value,
                width: 900
            }, {
                header: _withCtx(() => [
                    _createVNode(_unref(UIModalHeader), {
                        id: "modal-header",
                        type: "primary",
                        title: details.value.name,
                        onClose: hideModal
                    }, null, 8, ["title"])
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(UIModalContent), { id: "preview-modal-content" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                (loading.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
                                    : _createCommentVNode("", true),
                                _withDirectives(_createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("img", {
                                        id: `preview-${details.value._id}`,
                                        src: details.value.url,
                                        alt: "image",
                                        class: "w-auto preview-image",
                                        onLoad: findDimensions
                                    }, null, 40, _hoisted_6)
                                ], 512), [
                                    [_vShow, !loading.value]
                                ]),
                                (loading.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_12))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                        (details.value.published)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                _createVNode(_unref(CalendarIcon), { class: "w-3 h-3 mr-2 align-baseline" }),
                                                _createVNode(_unref(UITextSmRegular), null, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(t)('common.publishedAt', [timeFromNow(details.value.published)])), 1)
                                                    ]),
                                                    _: 1
                                                })
                                            ]))
                                            : _createCommentVNode("", true),
                                        (details.value.size)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                _createVNode(_unref(HardDriveIcon), { class: "w-3 h-3 mr-2" }),
                                                _createVNode(_unref(UITextSmRegular), null, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(formatBytes)(details.value.size)), 1)
                                                    ]),
                                                    _: 1
                                                })
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_16, [
                                            _createVNode(_unref(Expand04Icon), { class: "w-3 h-3 mr-2" }),
                                            _createVNode(_unref(UITextSmRegular), null, {
                                                default: _withCtx(() => {
                                                    var _a, _b;
                                                    return [
                                                        _createTextVNode(_toDisplayString(`${(_a = dimensions.value) === null || _a === void 0 ? void 0 : _a.width} x ${(_b = dimensions.value) === null || _b === void 0 ? void 0 : _b.height} PX`), 1)
                                                    ];
                                                }),
                                                _: 1
                                            })
                                        ]),
                                        _createElementVNode("div", _hoisted_17, [
                                            (details.value.showDownload)
                                                ? (_openBlock(), _createBlock(_unref(UIButton), {
                                                    key: 0,
                                                    id: "download",
                                                    type: "default",
                                                    class: "flex mr-2 py-1 w-10",
                                                    size: "small",
                                                    disabled: false,
                                                    loading: false,
                                                    ghost: false,
                                                    quaternary: false,
                                                    circle: false,
                                                    text: false,
                                                    onClick: downloadMediaFile
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(Download01Icon), { class: "w-5 h-5 cursor-pointer" })
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true),
                                            (details.value.showCopyLink)
                                                ? (_openBlock(), _createBlock(_unref(UIButton), {
                                                    key: 1,
                                                    id: "copy-link",
                                                    type: "tertiary",
                                                    class: _normalizeClass(["flex", { 'w-full': _unref($state).mediaModal }]),
                                                    size: "medium",
                                                    disabled: false,
                                                    loading: false,
                                                    ghost: false,
                                                    quaternary: false,
                                                    circle: false,
                                                    text: false,
                                                    onClick: copyLink
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(Link02Icon), { class: "w-5 h-5 mr-2 cursor-pointer" }),
                                                        _createVNode(_unref(UITextSmRegular), null, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_unref(t)('common.copyLink')), 1)
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                }, 8, ["class"]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        (details.value.showImportButton)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                _createVNode(_unref(UIButton), {
                                                    id: "import-to-media",
                                                    type: "tertiary",
                                                    class: "flex mr-3 w-full",
                                                    size: "medium",
                                                    disabled: false,
                                                    loading: false,
                                                    ghost: false,
                                                    quaternary: false,
                                                    circle: false,
                                                    text: false,
                                                    onClick: importToMediaLibrary
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(DownloadCloud02Icon), { class: "w-5 h-5 mr-2 cursor-pointer" }),
                                                        _createVNode(_unref(UITextSmRegular), null, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_unref(t)('common.importToMediaLibrary')), 1)
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                }),
                                                (details.value.user)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                        _createElementVNode("div", _hoisted_20, [
                                                            _createVNode(_unref(UserCircleIcon), { class: "w-3 h-3 mr-2" }),
                                                            _createVNode(_unref(UITextSmRegular), null, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(`${_unref(t)('common.by')} ${details.value.user}`), 1)
                                                                ]),
                                                                _: 1
                                                            })
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]))
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["show"]));
        };
    }
});
